import { useParams, useNavigate } from 'react-router-dom';
import BackgroundContainer from 'components/shared/backgroundContainer';
import ResetPasswordForm from '../../shared/resetPasswordForm';
import {
  API_JOIN_ON_INVITE,
  API_RESET_PASSWORD,
} from '../../../constants/apiRoutes';
import http from '../../../utility/http';
import { trimString } from '../../../utility/helpers';
import { useTranslations } from '../../../utility/useTranslations';
import { APP_PAGES } from '../../../constants/pages';

const ResetPasswordPage = props => {
  const navigate = useNavigate();
  const { name, uid, token } = useParams();
  const translations = useTranslations(APP_PAGES.RESET_PASSWORD);

  const handleSubmitHandler = (values, _, setSubmitting) => {
    const resolveUrl =
      name && name.length > 0 ? API_JOIN_ON_INVITE : API_RESET_PASSWORD;

    http
      .post(resolveUrl, {
        new_password: trimString(values.password),
        uid,
        token,
      })
      .then(() => {
        navigate('/');
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <BackgroundContainer translations={translations.authContainer}>
      <ResetPasswordForm
        {...props}
        translations={translations}
        name={name}
        navigate={navigate}
        handleSubmitHandler={handleSubmitHandler}
      />
    </BackgroundContainer>
  );
};

export default ResetPasswordPage;
